import { render, staticRenderFns } from "./IMongoLogsCollectionPicker.vue?vue&type=template&id=b2230d7c"
import script from "./IMongoLogsCollectionPicker.vue?vue&type=script&lang=js"
export * from "./IMongoLogsCollectionPicker.vue?vue&type=script&lang=js"
import style0 from "./IMongoLogsCollectionPicker.vue?vue&type=style&index=0&id=b2230d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports